export const SET_CASE_LIST_PIE_CHART = "SET_CASE_LIST_PIE_CHART";
export const SET_CASE_STATUS_PIE_CHART = "_PIE_CHART";
export const SET_DOMAINS_PIE_CHART = "DOMAINS_PIE_CHART";
export const SET_REG_STATUS_PIE_CHART = "REG_STATUS_PIE_CHART";
export const SET_RISK_CATEGORIES_PIE_CHART = "RISK_CATEGORIES_PIE_CHART";
export const SET_SOURCE_CATEGORIES_PIE_CHART = "SOURCE_CATEGORIES_PIE_CHART";
export const SET_TIME_LINE = "TIME_LINE";
